import Vue from 'vue';
import Vuex from 'vuex';
import Http from 'axios';

import navigation from '#app#/store/modules/navigation.js';
import blog from '#app#/store/modules/blog.js';
import event from '#app#/store/modules/event.js';

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        navigation,
        blog,
        event,
    },

    state: {
        pageLoading: window.SSR ? false : true,
        locale: null,
        languages: [],
        routes: [],
    },

    getters: {
        getRouteBySlug: (state) => (slug) => {
            return state.routes.find(route => route.slug == slug) || null;
        },

        getPageById: (state) => (id) => {
            const route = state.routes.find(route => {
                return typeof route.uriable !== 'undefined' && route.uriable.parent_id == id
            });
            return route ? route.uriable.parent : null;
        },

        homePage: (state) => {
            const route = state.routes.find(route => {
                return typeof route.uriable !== 'undefined' && route.uriable.parent.is_home
            });
            return route ? route.uriable.parent : null;
        },

        activeLanguage(state) {
            return state.languages.find(language => language.is_current == true) || null;
        }
    },

    mutations: {
        setLocale(state, locale) {
            state.locale = locale;
        },

        setLoading(state, loading) {
            state.pageLoading = loading;
        },

        setRoutesData(state, routes) {
            state.routes = routes;
        },

        setLanguages(state, languages) {
            state.languages = languages;
        },
    },

    actions: {
        loadRoutesData({ commit }) {
            return Http.get('/api/routes').then(res => {
                commit('setRoutesData', res.data);
            });
        },

        loadLanguages({ commit }) {
            return Http.get('/api/languages').then(res => {
                commit('setLanguages', res.data);
            });
        },
    }
});

export default store;


// WEBPACK FOOTER //
// ../default-js/js/store/index.js